import axios from "axios";
import { refreshAccessTokenInterceptor } from "../utils/refreshTokens";
import { fullAPIURL } from "../utils/requests";
import {
  requestAccessTokenInterceptor,
  responseStatusInterceptor,
} from "../utils/axios.utils";

const quicksightAxios = axios.create({
  baseURL: `${fullAPIURL}/v2/client/client`,
  headers: { "Content-Type": "application/json" },
  validateStatus: null,
});

quicksightAxios.interceptors.request.use(requestAccessTokenInterceptor);

quicksightAxios.interceptors.request.use(refreshAccessTokenInterceptor);

quicksightAxios.interceptors.response.use(responseStatusInterceptor);

export type GetReport = {
  clientUuid?: string;
  dashboardId?: string;
};

export type GetReportResult = {
  embedUrl: string;
};

export async function getQuicksightEmbedUrl({
  clientUuid,
  dashboardId,
}: GetReport): Promise<GetReportResult | null> {
  if (!dashboardId || !clientUuid) {
    return null;
  }

  const response = await quicksightAxios.get(
    `${clientUuid}/report/quicksight?dashboardId=${dashboardId}`,
  );
  return response.data;
}
